export function getUnitSettingsByAlias({ unit_settings: unitSettings }, alias) {
  if (!unitSettings.length) return false

  const valueUnitSettingsWithCurrentAlias = unitSettings.find(setting => setting.type.alias === alias)?.value

  return Boolean(parseInt(valueUnitSettingsWithCurrentAlias))
}
